import { z } from 'zod'

export const afterValid = <Schema extends z.ZodType>(
  schema: Schema,
  refine: (value: z.output<Schema>, context: z.RefinementCtx) => void
): z.ZodType<z.output<Schema>, z.input<Schema>> =>
  schema.pipe(z.custom<z.output<Schema>>().superRefine(refine))
